export const FILE_NAME_TYPE = {
    LOGO: 'logo',
    GALLERY: 'gallery',
    IMAGE_LAYOUT: 'layout',
    STORAGE: 'STORAGE',
    AVATAR: 'AVATAR',
    ICON: 'ICON',
    BANNER_BG: 'bannerBg',
    IMAGE: 'IMAGE',
};